import { useState } from 'react';
import firmService from '../../../services/firmService';

/**
 * useFirmPatch — optimistic single-field patch for firm widgets.
 * Returns { local, savingField, patch } where `local` is the firm object with
 * any in-flight optimistic overrides applied. `patch({ field: value })` saves
 * via firmService.updateFirm, rolls back on error, and calls onRefresh on success.
 */
export default function useFirmPatch(firm, firmId, onRefresh) {
  const [overrides, setOverrides] = useState({});
  const [savingField, setSavingField] = useState(null);
  const local = { ...firm, ...overrides };

  const patch = async (partial) => {
    const key = Object.keys(partial)[0];
    setOverrides(prev => ({ ...prev, ...partial }));
    setSavingField(key);
    try {
      await firmService.updateFirm(firmId, { ...local, ...partial });
      onRefresh?.();
    } catch (err) {
      setOverrides(prev => { const n = { ...prev }; delete n[key]; return n; });
      alert('Failed to save: ' + err.message);
    } finally {
      setSavingField(null);
    }
  };

  return { local, savingField, patch };
}
